import { __assign } from "tslib";
import { SEAT_SPACING, SEAT_CIRCLE_DIAMETER } from '../../constants';
import { SHAPE } from '../../interfaces';
import { getNextId } from '../../utils/id-generator';
import { getElement } from '../../utils/utils';
import { DH } from '../../hooks';
import { getFactualElementPosition } from '../../utils/bounding-boxes';
export var getSeatsAmount = function (size, spacing) {
    if (spacing === void 0) { spacing = SEAT_SPACING; }
    var reservedSeatSpace = spacing + SEAT_CIRCLE_DIAMETER;
    var amount = size < SEAT_CIRCLE_DIAMETER ? 0 : Math.floor(size / reservedSeatSpace) + 1;
    return amount;
};
export var getSeatsLength = function (seats, spacing) {
    if (spacing === void 0) { spacing = SEAT_SPACING; }
    return SEAT_CIRCLE_DIAMETER * seats + spacing * (seats - 1);
};
export var getSeatCapacity = function (definition) {
    var width = definition.width, height = definition.height, _a = definition.spacingBetweenSeats, spacingBetweenSeats = _a === void 0 ? SEAT_SPACING : _a, _b = definition.spacingBetweenRows, spacingBetweenRows = _b === void 0 ? SEAT_SPACING : _b;
    var seatsInRow = getSeatsAmount(width, spacingBetweenSeats);
    var rowsAmount = getSeatsAmount(height, spacingBetweenRows);
    return { seatsInRow: seatsInRow, rowsAmount: rowsAmount };
};
export var getRows = function (_a) {
    var definition = _a.definition, rowLabelGenerator = _a.rowLabelGenerator, _b = _a.absolutePosition, absolutePosition = _b === void 0 ? false : _b, svgContainer = _a.svgContainer, svgViewBox = _a.svgViewBox;
    var width = definition.width, startAt = definition.startAt, labelPosition = definition.labelPosition, reverseDirection = definition.reverseDirection, sectorLabel = definition.sectorLabel, sequence = definition.sequence, _c = definition.spacingBetweenSeats, spacing = _c === void 0 ? SEAT_SPACING : _c, _d = definition.spacingBetweenRows, rowSpacing = _d === void 0 ? SEAT_SPACING : _d, shapeBorderColor = definition.shapeBorderColor, shapeColor = definition.shapeColor, shapeTextColor = definition.shapeTextColor;
    var verticalReservedSeatSpace = rowSpacing + SEAT_CIRCLE_DIAMETER;
    var _e = getSeatCapacity(definition), seatsInRow = _e.seatsInRow, rowsAmount = _e.rowsAmount;
    var rows = [];
    var rowPositions = absolutePosition
        ? getActualRowPositions(definition, svgContainer, svgViewBox)
        : [];
    for (var rowIndex = 0; rowIndex < rowsAmount; rowIndex++) {
        var row = {
            id: absolutePosition ? getNextId() : rowIndex,
            type: SHAPE.ROW,
            angle: 0,
            x: 0,
            y: rowIndex * verticalReservedSeatSpace,
            width: width,
            height: SEAT_CIRCLE_DIAMETER,
            startAt: startAt,
            label: rowLabelGenerator.next().value.toString(),
            labelPosition: labelPosition,
            reverseDirection: reverseDirection,
            capacity: seatsInRow,
            sectorLabel: sectorLabel,
            sequence: sequence,
            spacing: spacing,
            shapeBorderColor: shapeBorderColor,
            shapeColor: shapeColor,
            shapeTextColor: shapeTextColor,
        };
        if (absolutePosition) {
            row.x = rowPositions[rows.length].x;
            row.y = rowPositions[rows.length].y;
            row.angle = definition.angle;
        }
        rows.push(row);
    }
    return rows;
};
var getActualRowPositions = function (definition, svgContainer, svgViewBox) {
    if (!svgContainer) {
        throw new Error('Cannot calculate absolute position of rows without having a reference to main SVG container');
    }
    var multiRowElement = getElement(definition.id, svgContainer, undefined);
    var rowNodeList = multiRowElement.querySelectorAll("[data-hook=".concat(DH.MULTI_ROW_TEMPORARY_ROW, "]"));
    var rowRootElements = [];
    rowNodeList.forEach(function (node) { return rowRootElements.push(node); });
    var rowSeatElements = rowRootElements.map(function (root) {
        var seats = root.querySelector("[data-hook=\"".concat(DH.MULTI_ROW_TEMPORARY_ROW_SEATS, "\"]"));
        return seats.querySelector('[data-measure-during-apply]') || seats;
    });
    var positions = rowSeatElements.map(function (el) {
        return getFactualElementPosition({
            element: el,
            definition: __assign(__assign({}, definition), { height: SEAT_CIRCLE_DIAMETER }),
            svgContainer: svgContainer,
            svgViewBox: svgViewBox,
        });
    });
    return positions;
};
//# sourceMappingURL=utils.js.map